
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa7d298a5c37c413d9ed0b88f900a3ddaen from './en.yaml'
            i18n.addResourceBundle('en', 'a7d298a5c37c413d9ed0b88f900a3dda', flattenObject(nsa7d298a5c37c413d9ed0b88f900a3ddaen), true, true);
        
        export default 'a7d298a5c37c413d9ed0b88f900a3dda';
    